module.exports = __webpack_public_path__ + "img/sxsjs4.532b4979.png";